import React, {Component} from 'react';
import Highcharts from "highcharts";

Highcharts.setOptions({
    lang: {
        thousandsSep: ','
    }
});


class ChartMonaBulan extends Component {
    constructor(props) {
    super(props);
        this.options = {
            sortIndicator: true,
            hideSizePerPage: true,
            paginationSize: 3,
            hidePageListOnlyOnePage: true,
            clearSearch: true,
            alwaysShowAllBtns: false,
            withFirstAndLast: false
        }
        this.state = {
            loading: false,
            activeTab: '1',
            data: this.props.data,
            label_x: this.props.label_x,
            label_y: this.props.label_y,
        }
    }

    getDataTable() {
        this.setState({ loading: true });
    }

    renderChart(){
        var option = {
                chart: {
                    type: 'column',
                },
                legend: {
                    enabled: false
                },
                title: {
                    text: (this.props.keterangan) ? 'Data ' + this.props.data.nama_pelanggan + ' ' + this.props.keterangan : '',
                    x: -20
                },
                subtitle: {
                    text: '<span style="color:#00CC33;">Download</span>' + '<br>' +
                        '<span style="color:#0000FF;">Upload</span>',
                    x: -20
                },
                xAxis: {
                    categories: this.props.data.category
                },
                yAxis: {
                    max: (this.props.data.pelanggan) ? this.props.data.pelanggan.max_download : null,
                    min: (this.props.data) ? this.props.data.rate.upload_avg : null,
                    title: {
                        text: 'Bandwidth'
                    },
                    plotLines: [{
                        value:  (this.props.data.pelanggan) ? this.props.data.pelanggan.max_download : 0,
                        color: 'red',
                        width: 2,
                        zIndex: 5
                    }]
                },
                tooltip: {
                    formatter: function () {
                        var tooltip;
                        if (this.series.name === 'Download') {
                            tooltip = '<span style="color:' + this.series.color + '">' + this.series
                                .name + '</span>: <b>' + this.point
                                .stackTotal + ' Mbps</b><br/>';
                        } else {
                            tooltip = '<span style="color:' + this.series.color + '">' + this.series
                                .name + '</span>: <b>' + this.y +
                                ' Mbps</b><br/>';
                        }
                        return tooltip;
                    }
                },
                plotOptions: {
                    column: {
                        stacking: 'normal',
                        pointPadding: 0,
                        borderWidth: 0
                    },
                    series: {
                        pointPadding: 0,
                        groupPadding: 0,
                        animation: false
                    }
                },
                credits: {
                    enabled: false
                },
                exporting: {
                    width: 900
                },
                series: this.props.data.series,
        
            };
            this.chart = new Highcharts.chart(this.refs.chart, option);
            this.chart.reflow();
    }

    componentDidMount() {
        this.renderChart();
    }
    
    
    componentDidUpdate(prevProps, prevState){
        if(this.props.data !== prevProps.data){
            // console.log(this.props.data)
            this.setState({data: this.props.data})
            this.renderChart();
            setTimeout(() => {
                this.chart.reflow();   
            }, 100);
        }
    }

    render() {
        // console.log(this.props.data)
        return (
            <div ref="chart"></div>
        );
    }
}

export default ChartMonaBulan;
